import React from 'react';
import { Card } from '@sisumail/ui';

interface Stats {
    totalIdentities: number;
    activeSubscriptions: number;
    recentMessages: number;
}

export function StatsCards({ stats }: { stats: Stats | undefined }) {
    if (!stats) return null;

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <Card className="flex flex-col gap-1">
                <h3 className="font-bold text-[10px] text-neutral-500 uppercase tracking-wider">
                    Total Identities
                </h3>
                <p className="font-bold text-2xl text-white">{stats.totalIdentities}</p>
            </Card>
            <Card className="flex flex-col gap-1">
                <h3 className="font-bold text-[10px] text-neutral-500 uppercase tracking-wider">
                    Active Subscriptions
                </h3>
                <p className="font-bold text-2xl text-emerald-400">
                    {stats.activeSubscriptions}
                </p>
            </Card>
            <Card className="flex flex-col gap-1">
                <h3 className="font-bold text-[10px] text-neutral-500 uppercase tracking-wider">
                    Recent Messages (24h)
                </h3>
                <p className="font-bold text-2xl text-blue-400">
                    {stats.recentMessages}
                </p>
            </Card>
        </div>
    );
}
